import React, {useEffect} from 'react';
import { Link } from 'react-router-dom';
import './NotificationSnippet.css';
// Redux
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store';  
// 通知一覧取得
import { fetchNotifications } from "../../redux/notificationsSlice";

const NotificationSnippet: React.FC = () => {
  const dispatch:AppDispatch = useDispatch();
  const notifications = useSelector((state: RootState) => state.notifications.values)
  const plant_code = useSelector((state: RootState) => state.queryParams.selectedPlantCode);
  const proc_code = useSelector((state: RootState) => state.queryParams.selectedProcCode);
  const mach_code = useSelector((state: RootState) => state.queryParams.machCode);

  // 5分おきに更新
  useEffect(()=>{
    const timerId = setInterval(() => {
      if ( plant_code != null && proc_code != null && mach_code != null) {
        //dispatch(fetchNotifications(plant_code, proc_code, mach_code));
      }
    }, 300000);
    return () => {
      clearInterval(timerId);
    };
  },[plant_code, proc_code, mach_code, dispatch]);

  if (notifications.length > 0) {
    return (
      <div>
        <div className="notification-snippet-container">
          <div className="notification-snippet">
            <Link to="/notifications">
              <img src="images/notifications-true.svg" alt="Notifications True Icon" className="icon" />
              {/* (setIntervalで5分に1回APIから情報を取得) */}
              <p>通知が{notifications.length}件あります。</p>
            </Link>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <div className="notification-snippet-container">
          <div className="notification-snippet">
            <img src="images/notifications-false.svg" alt="Notifications False Icon" className="icon" />
            {/* (setIntervalで5分に1回APIから情報を取得) */}
            <p>通知はありません。</p>
          </div>
        </div>
      </div>
    );
  }
};

export default NotificationSnippet;
